/**
 * MMP Metadata
 * This is a API for MMP Metadata
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: st116848@stud.uni-stuttgart.de.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Execution } from './execution';
import { Artifact } from './artifact';
import { Pipeline } from './pipeline';


export interface Run { 
    id?: string;
    name: string;
    version: string;
    createTime?: Date;
    status?: Run.StatusEnum;
    uri?: string;
    executions?: Array<Execution>;
    event?: Artifact;
    pipeline?: Pipeline;
    configuration?: { [key: string]: string; };
    annotations?: { [key: string]: string; };
}
export namespace Run {
    export type StatusEnum = 'SUCCESS' | 'FAILED' | 'RUNNING';
    export const StatusEnum = {
        SUCCESS: 'SUCCESS' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum,
        RUNNING: 'RUNNING' as StatusEnum
    };
}


